import { CodeBook } from "@king-ict/eupisi-ui/models";

import {
  useGetInstitutionListForUserQuery,
  useGetInstitutionListQuery,
} from "../../../queries";
import { Institution } from "../types";

export const filterCountiesByInstitutions = (
  institutions: Institution[] | undefined,
  counties: CodeBook[]
): CodeBook[] => {
  if (!institutions) return [];
  const uniqueCountyIds = Array.from(
    new Set(institutions.map((inst) => inst.countyId))
  );

  return counties.filter((county) => uniqueCountyIds.includes(county.id));
};

export const handleGetInstitutionListQuery = (
  showUser: boolean,
  skip: boolean = false
) => {
  if (showUser) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useGetInstitutionListForUserQuery(undefined, { skip });
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useGetInstitutionListQuery(undefined, { skip });
  }
};
